export default "__VITE_ASSET__CZMyVSwD__"